import React, {useEffect, useState} from 'react';
import {Button} from '@mui/material'
import styles from '../../assets/styles/modules/Join.module.css'
import logo from "../../assets/images/newssum_logo.svg";
import {emailAuthAPI, joinAPI} from "../../apis/user_service";

const JoinForm = () => {

    const [corpName, setCorpName] = useState({name: '', errorMsg : '', isError: false}) //corpname
    const [corpEmail, setCorpEmail] = useState({email: '', errorMsg : '', isError: false}) //userId
    const [password, setPassword] = useState({password: '', errorMsg : '', isError: false}) //password
    const [confirmPassword, setConfirmPassword] = useState({password: '', errorMsg : '', isError: false}) //password confirm
    const [emailCode, setEmailCode] = useState({code: '', errorMsg : '', isError: false}) //이메일 인증코드
    const [confirmCode, setConfirmCode] = useState({code: '', errorMsg : '', isError: false}) //이메일 인증코드 체크
    const [disableJoin, setDisableJoin] = useState(true)
    const [count , setCount] = useState(0) // 메일인증 횟수 상태

    const params = {
        userid: corpEmail.email,
        username: corpEmail.email,
        password: password.password,
        corpname: corpName.name,
    }

    useEffect(()=> {setCount(count+1)}, [emailCode])
    const goToMain = () => {window.location.replace('/')}

    const onSubmit = (e) => {
        e.preventDefault()
        joinAPI(params)
            .then(res => {
                if(res.resultcode === '200'){
                    setTimeout(goToMain, 1000)
                }
                else if (res.resultcode === '203') {
                    alert(`${res.msg}\n${res.data}`)
                } else {
                    alert(res.msg)
                }
            })
            .catch(err => console.log(err))
    }

    const preventSubmit = (e) => {
        if (e.keyCode === 13) {
            e.preventDefault();
        }
    }

    const checkForm = (val, type) => {
        const regEmail = /^([0-9a-zA-Z_\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/;
        const regPassword = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/;

        if(type === 'email') {
            return regEmail.test(val)
        }
        else if(type === 'password'){
            return regPassword.test(val)
        }
    }

    const sendConfirmCode = () => {
        if(count < 4 && checkForm(corpEmail.email, 'email')){
            emailAuthAPI(corpEmail.email)
                .then(res => setEmailCode({...corpName, code: res.data.securenum}))
                .catch(err => console.log(err.message))
        }
        else {
            alert('인증 요청 제한 횟수를 초과했습니다.')
            window.location.replace('/login')
        }
    }

    const activeJoinBtn = () => {
        if(!!params.userid && !!params.password && !!params.corpname && !!params.username && params.password === confirmPassword.password ){
            setDisableJoin(false) // false is btn active
        }
        else {
            setDisableJoin(true)
        }
    }


    return (
        <div className={styles.account}>
            <div className={styles.account_wrapper}>
                <div className={styles.account_form}>
                    <img src={logo} className={styles.logo} alt='투디지트 로고' onClick={goToMain}/>
                    <form className={styles.form} action='javascript://' method='post' onSubmit={onSubmit}>
                        <div className={styles.input_group}>
                            <span className={styles.input_label}>이름</span>
                            <span className={styles.required}>&nbsp;필수</span>
                                <input className={styles.input}  name="corpName" type="text" placeholder='이름을 입력해주세요.' autoFocus
                                    onChange={(e) => setCorpName({...corpName, name: e.target.value})}
                                    onKeyDown={(e)=>preventSubmit(e)}
                                    onBlur={() => {
                                        if (corpName.name.length === 0) {
                                            setCorpName({...corpName, isError: true, errorMsg: '필수정보입니다'})
                                        } else {
                                            setCorpName({...corpName, isError: false})
                                        }
                                    }}
                                />

                            <span className={styles.error} style={{display: corpName.isError ? 'block' : 'none'}}>{corpName.errorMsg}</span>
                        </div>
                        <div className={styles.input_group}>
                            <span className={styles.input_label}>이메일 인증</span>
                            <span className={styles.required}>&nbsp;필수</span>
                            <div className={styles.email_auth} >
                                <input className={styles.input} name="corpEmail" type="text" placeholder='이메일을 입력하세요.'
                                    onChange={(e) => setCorpEmail({...corpEmail, email: e.target.value})}
                                    onKeyDown={(e)=>preventSubmit(e)}
                                    onBlur={() => {
                                        if(corpEmail.email.length === 0){
                                            setCorpEmail({...corpEmail, isError: true, errorMsg: '필수정보입니다'})
                                        } else if (!checkForm(corpEmail.email, 'email')){
                                            setCorpEmail({...corpEmail, isError: true, errorMsg: '올바른 이메일 형식이 아닙니다.'})
                                        } else {
                                            setCorpEmail({...corpEmail, isError: false})
                                        }
                                    }}
                                />
                                <Button id={styles.send_code_btn} variant='contained'
                                        sx={confirmCode.code.length !== 0 && !confirmCode.isError ? {color:'#999', backgroundColor: '#d8d8d8'} : {}}
                                        onClick={sendConfirmCode}
                                        disabled={confirmCode.code.length !== 0 && !confirmCode.isError}
                                >
                                    {confirmCode.code.length !== 0 && !confirmCode.isError ? '인증완료' : '인증받기'}
                                </Button>
                            </div>
                            <span className={styles.error} style={{display: corpEmail.isError ? 'block' : 'none' }}>{corpEmail.errorMsg}</span>
                            <div>
                                {/*remove autocomplete  */}
                                <input className={styles.hidden} aria-hidden='true'/>
                                <input className={styles.hidden} type='password' aria-hidden='true'/>
                                {/*real input start*/}
                                <input name="EmailCode" type="text" placeholder='메일로 발송된 코드를 입력하세요.' className={styles.input} autoComplete='new-password'
                                    onKeyUp={(e)=> setConfirmCode({...confirmCode, code:e.target.value})}
                                    onKeyDown={(e)=>preventSubmit(e)}
                                    onBlur={(e) => {
                                        if(e.target.value ===''){
                                            setConfirmCode({...confirmCode,errorMsg : '인증코드를 입력해주세요.', isError: true})
                                        }
                                        else if(confirmCode.code === emailCode.code){
                                            setConfirmCode({...confirmCode,errorMsg : '', isError: false})
                                        } else {
                                            setConfirmCode({...confirmCode,errorMsg : '인증코드를 입력해주세요.', isError: true})
                                        }
                                    }}
                                />
                            </div>
                            <span className={styles.error} style={{display: confirmCode.isError ? 'block' : 'none' }}>{confirmCode.errorMsg}</span>
                            <span className={styles.message} style={{display: emailCode.code === '' ? "none": "block"}}>
                                {'귀하의 이메일 계정으로 인증코드가 발송되었습니다.\n받은 메일함과 스팸 메일함을 확인해주세요.\n메일 확인 후, 인증코드를 복사해 입력창에 붙여넣고 엔터키를 눌러주세요.'}
                            </span>
                        </div>
                        <div className={styles.input_group}>
                            <span className={styles.input_label}>비밀번호</span>
                            <span className={styles.required}>&nbsp;필수</span>
                            <div>
                                <input className={styles.input} name="password" placeholder="8~16자 영문 대 소문자, 숫자, 특수문자를 사용하세요."
                                    type="password" autoComplete='new-password'
                                    onChange={(e)=> setPassword({...password, password: e.target.value})}
                                    onKeyDown={(e)=>preventSubmit(e)}
                                    onBlur={() => {
                                        if(password.password.length === 0){
                                            setPassword({...password, isError: true,  errorMsg: '필수정보입니다.'})
                                        } else if (!checkForm(password.password, 'password')){
                                            setPassword({...password, isError: true, errorMsg: '8~16자 영문 대 소문자, 숫자, 특수문자를 사용하세요.'})
                                        } else {
                                            setPassword({...password, isError: false})
                                        }
                                    }}
                                />
                            </div>
                            <span className={styles.error} style={{display: password.isError ? 'block' : 'none' }}>{password.errorMsg}</span>
                        </div>
                        <div className={styles.input_group}>
                            <span className={styles.input_label}>비밀번호 재확인</span>
                            <span className={styles.required}>&nbsp;필수</span>
                            <div>
                                <input className={styles.input} name="passwordConfirm" type="password" autoComplete='new-password'
                                    onChange={(e) => setConfirmPassword({...confirmPassword, password: e.target.value}) }
                                    onKeyDown={(e)=>preventSubmit(e)}
                                    onBlur={(e) => {
                                        if(e.target.value === ''){
                                            setConfirmPassword({...confirmPassword, errorMsg : '필수정보입니다.', isError: true})
                                        }
                                        else if(password.password === confirmPassword.password){
                                            setConfirmPassword({...confirmPassword, errorMsg : '비밀번호가 일치합니다', isError: false})
                                        } else {
                                            setConfirmPassword({...confirmPassword, errorMsg : '비밀번호가 일치하지않습니다.', isError: true})
                                        }
                                        activeJoinBtn()
                                    }}
                                />
                            </div>
                            <span className={styles.error} style={{color: confirmPassword.isError ? '#e63d44':'#3d6ae6'}}>
                                {confirmPassword.errorMsg}
                            </span>
                        </div>
                        <Button className={styles.join_btn} variant='contained'
                                sx={disableJoin ? {} : {backgroundColor: "#000", color: "#fff" }}
                                onClick={onSubmit} disabled={disableJoin}>가입완료</Button>
                    </form>
                </div>
            </div>
        </div>
    )
};

export default JoinForm;
